"use client"
import React from "react";
import {connect} from "react-redux";
import {Menu} from "semantic-ui-react";

import ToggleDisplay from "../../common/components/ToggleDisplay"

import {Tab, TabMultiple} from "./Tab";

import {selectCurrentTab} from "./tabsSelectors";
import {selectTab} from "./tabsActions";


//<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/semantic-ui/2.5.0/semantic.min.js"></link>


const mapState = (state) => {
    const currentTab = selectCurrentTab(state);

    return {currentTab};
}

const actions = {onTabClick : selectTab};

export const TabBar = (props) => {
    const {tabs, currentTab, onTabClick, onAfterDeleteTab, listenerParent, onSelectedFromMenu, maxTab, isDesktop, isMenuActive, ...otherProps} = props;
    
    const {innerWidth} = window;

    let _maxTab=5;
    _maxTab = maxTab;
    if (_maxTab===undefined) {
        if (!isDesktop){
            _maxTab=2;
        }
        else if (isMenuActive){ 
            _maxTab=Math.trunc((innerWidth-(innerWidth*0.20))/200);
        }
        else{
            _maxTab=Math.trunc(innerWidth/200);
        }

    };
    
    const tabItems = tabs.filter((x,index) => index<=_maxTab).map((tabInfo, index) => {
        const {name, label} = tabInfo;
        if (index<_maxTab){
            return (<Tab
                key={name}
                name={name}
                label={label}
                active={currentTab === name}
                onClick={onTabClick}
                onAfterDeleteTab={onAfterDeleteTab}
                index = {index}
            />)
        }
        else{
            return (<TabMultiple
                key={"multiple"}
                tabs ={tabs} 
                currentTab ={currentTab} 
                onTabClick = {onTabClick }
                onAfterDeleteTab ={onAfterDeleteTab}
                active={currentTab === name}
                onClick={onTabClick}
                onSelectedFromMenu={onSelectedFromMenu}
            />)
        }

    });

    const tabPanels = tabs.map(tabInfo => {
        const {name, codMenu, selectedTipoGenerica, component : TabComponent} = tabInfo;
        
        return (
            <ToggleDisplay show={name === currentTab} key={name}  >
                <TabComponent codMenu={codMenu} selectedTipoGenerica={selectedTipoGenerica} visible = {name === currentTab} />
            </ToggleDisplay>
        )
    })

    return (
        <div className="layout-main">
            
            <Menu tabular attached="top" {...otherProps}>
                {tabItems}
            </Menu>
            {tabPanels}
        </div>
    )
}

export default connect(mapState, actions)(TabBar);
